import React, { useContext } from 'react';
import { MapMarkerIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { Tag, VARIANT } from 'baseui/tag';
import { SimpleEnquiries } from '@gtintel/platform-types';
import { SubjectsContext } from '../../ProjectApp/context';
const SubjectType = ({
  subject
}) => {
  let subjectType = subject.is_individual ? 'Individual' : 'Entity';
  const ctx = useContext(SubjectsContext);
  const [, theme] = useStyletron();
  if (subject.subject_type) {
    subjectType = ctx.subjectTypes()[subject.subject_type];
  }
  return <Tag color={theme.colors.gray500} closeable={false} kind="custom" variant={VARIANT.solid}>
      {subjectType}
    </Tag>;
};
const Jurisdictions = ({
  subject
}) => {
  const [css] = useStyletron();
  const subjectsCtx = React.useContext(SubjectsContext);
  const jurisdictions = subjectsCtx.jurisdictions(String(subject.id)).map(j => j.name);
  return <>
      <HeadingLevel>
        <Heading styleLevel={5} className={css({
        display: 'inline'
      })}>
          Jurisdictions:
        </Heading>
      </HeadingLevel>
      {jurisdictions.map(jurisdiction => <Tag closeable={false} variant={VARIANT.light} key={jurisdiction}>
          {jurisdiction}
        </Tag>)}
    </>;
};
const SubjectCard = ({
  subject
}) => {
  const [css, theme] = useStyletron();
  const addressText = subject.address ? subject.address.split('\n').join(', ') : null;
  return <div className={css({
    backgroundColor: theme.colors.backgroundPrimary,
    border: 'solid 1px #eee',
    borderRadius: '10px',
    padding: '1em 1.5em',
    margin: '1.0em'
  })} data-testid="subject-card">
      <div className={css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    })}>
        <Heading styleLevel={4}>{subject.name}</Heading>
        <SubjectType subject={subject} />
      </div>
      <Jurisdictions subject={subject} />
      {subject.address && <div className={css({
      display: 'grid',
      gridColumnGap: '8px',
      gridTemplateColumns: '[icon] 20px [text] auto',
      marginBottom: '14px'
    })}>
          <MapMarkerIcon />
          <p className={css({
        alignSelf: 'center',
        gridColumnStart: 'text',
        marginBottom: '0'
      })}>
            {addressText}
          </p>
        </div>}
      <div className={css({
      padding: '1em'
    })}>
        {subject.description && <div dangerouslySetInnerHTML={{
        __html: subject.description
      }}></div>}
        {subject.additional_info && <p>{subject.additional_info}</p>}

        <div className={css({
        marginTop: '14px',
        p: {
          marginBottom: '0'
        }
      })}>
          {subject.site_name && <p>{subject.site_name}</p>}
          {subject.category && <p>
              <b>Category: </b>
              {subject.category}
            </p>}
          {!!subject.number_of_enquiries && <p>
              <b>Number of enquiries: </b>
              {SimpleEnquiries[subject.number_of_enquiries]}
            </p>}
        </div>
      </div>
    </div>;
};
export const SubjectList = ({
  subjects
}) => {
  const [css] = useStyletron();
  return <div className={css({
    margin: '2em 0'
  })} data-testid="subject-list">
      <Heading>Subjects</Heading>
      <HeadingLevel>
        <div className={css({
        display: 'flex',
        flexFlow: 'column wrap',
        gap: '14px'
      })}>
          {subjects.map(subject => <div>
              <SubjectCard key={subject.id} subject={subject} />
            </div>)}
        </div>
      </HeadingLevel>
    </div>;
};
export default SubjectCard;